import { APIMethods } from './../types/state/apiTypes'
import { ReqBodyWithHeaders, ReqBodyWithoutHeaders } from '../types/state'

export const fetchApi = async (
	obj: ReqBodyWithHeaders | ReqBodyWithoutHeaders,
	useHeaders = false
) => {
	if (useHeaders) {
		const { url, client, method, sessionId, ...reqObj } = obj
		const headers = getHeaders(client, sessionId)
		if (method === APIMethods.GET) {
			return await fetch(url, {
				method,
				headers,
			}).then((res) => res.json())
		} else {
			return await fetch(url, {
				method,
				headers,
				body: JSON.stringify(reqObj),
			}).then((res) => res.json())
		}
	} else {
		const { url, ...reqObj } = obj
		return await fetch(url, { ...reqObj }).then((res) => res.json())
	}
}

export const getApiBaseUrl = () => {
	let baseurl = ''
	if (process.env.name === 'dev' || process.env.name === 'preprod') {
		baseurl = 'https://api-gateway.juno.preprod.lenskart.com/'
		// baseurl = 'https://api.lenskart.com/'
	} else {
		baseurl = 'https://api.lenskart.com/'
	}
	return baseurl
}

export const getFireBaseUrl = () => {
	let firebaseUrl = ''
	if (process.env.name === 'dev' || process.env.name === 'preprod') {
		firebaseUrl = `https://stage.lenskart.io/api/v1/static`
	} else {
		firebaseUrl = `https://area51.lenskart.io/api/v1/static`
	}
	return firebaseUrl
}

const getHeaders = (client: string, sessionId: string) => {
	return {
		'Content-Type': 'application/json',
		'x-api-client': client,
		'x-country-code': 'in',
		'x-session-token': sessionId,
		'x-b3-traceid': `99${Date.now()}`,
	}
}
